export const prepareOptions = (maxQuantity: number): number[] => {
  const options: number[] = [];

  for (let option = 1; option <= maxQuantity; option++) {
    options.push(option);
  }

  return options;
};
